import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './DrawerCard.module.scss'

const DrawerCard = ({
  title,
  icon,
  badge,
  collapsible = false,
  defaultExpanded = true,
  children,
  className = '',
  fullWidth = false,
  variant = 'default'
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)

  const handleToggle = () => {
    if (collapsible) {
      setIsExpanded(prev => !prev)
    }
  }

  const HeaderTag = collapsible ? 'div' : 'div'
  const headerProps = collapsible
    ? {
      onClick: handleToggle,
      role: 'button',
      tabIndex: 0,
      onKeyDown: (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          handleToggle()
        }
      },
      'aria-expanded': isExpanded
    }
    : {}

  const variantClass = variant === 'featured' ? styles.featured : ''

  return (
    <Box
      className={`${styles.card} ${isExpanded ? styles.expanded : styles.collapsed} ${fullWidth ? styles.fullWidth : ''} ${variantClass} ${className}`}
    >
      <HeaderTag
        className={collapsible ? styles.cardHeader : styles.staticCardHeader}
        {...headerProps}
      >
        <Box className={styles.cardHeaderLeft}>
          {icon && (
            <Box className={styles.cardIcon}>
              {typeof icon === 'string' ? <FontAwesomeIcon icon={icon} /> : icon}
            </Box>
          )}
          <Typography className={styles.cardTitle}>{title}</Typography>
        </Box>

        <Box className={styles.cardHeaderRight}>
          {badge && <Box className={styles.cardBadge}>{badge}</Box>}
          {collapsible && (
            <Box className={`${styles.chevron} ${isExpanded ? styles.chevronExpanded : ''}`}>
              <FontAwesomeIcon icon="chevron-down" />
            </Box>
          )}
        </Box>
      </HeaderTag>

      <Box className={styles.contentWrapper} aria-hidden={collapsible && !isExpanded}>
        <Box className={styles.cardContent}>
          {children}
        </Box>
      </Box>
    </Box>
  )
}

DrawerCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  badge: PropTypes.node,
  collapsible: PropTypes.bool,
  defaultExpanded: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'featured'])
}

export default DrawerCard
